import { FormEvent, useState } from 'react';

import { useRouter } from 'next/router';

import qs from 'qs';

import styles from './QueryFilter.module.scss';

interface Props {
  urlPrefix?: string;
}

const QueryFilter: React.FC<Props> = ({ urlPrefix = '/katalog' }) => {
  const router = useRouter();
  const [query, setQuery] = useState(router.query.query);
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const params = {
      size: router.query.size,
      query,
    };
    router.push(`${urlPrefix}?${qs.stringify(params)}`);
  };
  return (
    <form onSubmit={handleSubmit} className={styles.queryFilter}>
      <input
        name="query"
        placeholder="Wyszukaj..."
        type="text"
        value={query}
        onChange={({ target: { value } }) => setQuery(value)}
      />
      <button type="submit" />
    </form>
  );
};
export default QueryFilter;
